import React, { useState } from 'react'
import { Container, Checkbox, Button, Grid, Link, makeStyles,  CssBaseline, FormControl, Input, InputLabel, InputAdornment, IconButton, CircularProgress, TextField } from '@material-ui/core';
import axios from 'axios';
import { useHistory } from 'react-router';
import { TermsAndConditionsModal } from '../../components/modals/TermsAndConditionsModal';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { Logo } from '../../components/ui/Logo';
import { icon_backButton } from '../../assets/images/images';
import toast from 'react-hot-toast';
import { ISignUpUser } from '../../interface/interface';
import { planEatApi } from '../../planEatApi/PlanEatApi';
import { ILogin } from '../../datasolvr/ServicesFacade';

const useStyles = makeStyles((theme: any) => ({
    topbarContainer: {
        padding: 12,
        top: 0,
        left: 0,
        right: 0,
        width: '20%',
        display: 'grid',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: "absolute"
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: 50,
    },
    title: {
        marginTop: '2%',
        marginBottom: '5%',
        fontSize: 20,
        fontWeight: 700
    },
    inputFieldContainer: {
        marginBottom: '5px'
    },
    signUpContainer: {
        display: 'grid',
    },
    termsOfConditionContainer: {
        display: 'flex',
        flexDirection: 'row',
        minWidth: '100%',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    form: {
        width: "100%",
        marginTop: theme.spacing(1)
    },
    signUpButton: {
        color: 'white',
        padding: 10,
        fontWeight: 700,
        letterSpacing: 2,
        marginTop: 25
    },
    link: {
        color: '#999999',
        marginTop: '15%'
    },
    loader: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
        zIndex: 200,
    },
    loaderText: {
        display: "flex",
        justifyContent: "center",
        marginTop: 25,
        width: "100%"
    }
}));


export const SignUp: React.FC = () => {
    // Styling
    const classes = useStyles();

    // Routing
    let history = useHistory();

    // State
    const [hidden, setHidden] = useState(true);
    const [loadingHidden,setLoadingHidden] = useState(true);
    const [checked, setChecked] = useState(false);
    const [isSendingVerifyEmail, setIsSendingEmail] = useState(false);
    const [signedUp, setSignedUp] = useState(false);
    const [signUpUser, setSignUpUser] = React.useState<ISignUpUser>({
        email: '',
        password: '',
        confirmPassword: '',
        showPassword: false
    });

    const signUp = () => {
        if (signUpUser.password === signUpUser.confirmPassword) {
            createApplicationUser();
        } else {
            toast.error("Password didn't match")
        }
    };

    const createApplicationUser = () => {
        var crecentials: ILogin = {
            'userId': signUpUser.email.toLowerCase(),
            'password': signUpUser.password
        };
        setIsSendingEmail(true)
        planEatApi.postSignUp(crecentials)
        .then((response) => {
            setSignedUp(true)
            setLoadingHidden(true)
            setIsSendingEmail(false)
            postLogin(crecentials)
        }).catch((error) => {
            setSignedUp(false)
            setLoadingHidden(true)
            setIsSendingEmail(false)

            if(error.response.data.content.length > 0){
                toast.error(error.response.data.content[error.response.data.content.length-1].message)
            }  else {
                toast.error("Failed sign up")
            }
        })
    }

    function postLogin(credentials: ILogin){
        planEatApi.postLogin(credentials)
        .then((response) => {
            localStorage.setItem("token",response.data.token)
            toast.success("Successfully signed up")
        })
    }

    const handleChange = (prop: keyof ISignUpUser) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setSignUpUser({ ...signUpUser, [prop]: event.target.value });
    };

    const handleClickShowPassword = () => {
        setSignUpUser({ ...signUpUser, showPassword: !signUpUser.showPassword });
    };

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    return (
        <div className={classes.signUpContainer}>
            <div className={classes.topbarContainer}>
                <img src={icon_backButton} alt="backButton" onClick={() => { history.push('') }} style={{ cursor: 'pointer' }} />
            </div>
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <div className={classes.paper}>
                    <Logo variant='normal' />   
                    <div className={classes.title}>
                        Sign up
                    </div>
                </div>
                <div className={classes.form}>
                    {
                        !signedUp && !isSendingVerifyEmail ?
                        <div>
                            <div className={classes.inputFieldContainer}>
                                <TextField
                                    margin="normal"
                                    fullWidth
                                    id="email"
                                    label="Email"
                                    name="email"
                                    autoComplete="email"
                                    autoFocus
                                    value={signUpUser.email}
                                    type="email"
                                    autoCorrect="off"
                                    autoCapitalize="none"
                                    onChange={handleChange('email')}
                                    required />
                                <FormControl
                                    margin="normal"
                                    fullWidth>
                                    <InputLabel htmlFor="standard-adornment-password">Password</InputLabel>
                                    <Input
                                        id="standard-adornment-password"
                                        type={signUpUser.showPassword ? 'text' : 'password'}
                                        value={signUpUser.password}
                                        onChange={handleChange('password')}
                                        endAdornment=
                                        {
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    size="small"
                                                >
                                                    {signUpUser.showPassword ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                    />
                                </FormControl>
                                <FormControl
                                    margin="normal"
                                    fullWidth>
                                    <InputLabel htmlFor="standard-adornment-password">Confirm Password</InputLabel>
                                    <Input
                                        id="standard-adornment-password"
                                        type={signUpUser.showPassword ? 'text' : 'password'}
                                        value={signUpUser.confirmPassword}
                                        onChange={handleChange('confirmPassword')} />
                                </FormControl>
                            </div>
                            <div className={classes.termsOfConditionContainer} hidden>
                                <Checkbox onClick={() => { setChecked(!checked) }} />
                                <div>
                                    I have read and agree to the <Link onClick={() => { setHidden(false) }}><b> terms and conditions</b> </Link>
                                </div>
                            </div>
                            <Button
                                className={classes.signUpButton}
                                variant='contained'
                                onClick={signUp}
                                fullWidth
                            >
                                Create account
                            </Button>
                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Link variant="body2" color="inherit" onClick={() => { history.push("/") }} className={classes.link}>
                                    Already have an account? <b>Log in</b>
                                </Link>
                            </Grid> 
                            <TermsAndConditionsModal hidden={hidden} setHidden={setHidden}></TermsAndConditionsModal>
                        </div>
                        : isSendingVerifyEmail ?
                        <div>
                            <div className={classes.loader}>
                                <div className="lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                            </div>
                            <div className={classes.loaderText}>
                                Sending verification mail...
                            </div>
                        </div>    
                        :
                        <div style={{
                            display: "flex",
                            justifyContent:'center',
                            alignItems:'center',
                            width: "100%",
                            marginTop:150,
                            zIndex: 2,
                            fontSize: 16
                        }}
                        >
                            Check your email inbox for a PlanEat Sign Up mail. It is potentially located in the spam folder
                        </div>
                    }
                </div>
            </Container>
            <div hidden={loadingHidden} style={{
                    position: "fixed",
                    display: "flex",
                    justifyContent:'center',
                    alignItems:'center',
                    width: "100%",
                    height: "100%",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0,0,0,0.5)",
                    zIndex: 2
                }}>
                    <CircularProgress />
            </div>
        </div>
    );
}